// --- General Utilities ---
export const normalizeAlnumLower = (s: any): string =>
  (s ?? "")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const trimLower = (s: any): string => (s ?? "").toString().trim().toLowerCase();


export async function postJsonWithBearer<TResponse = any>(
  url: string,
  userToken: string,
  payload: unknown
): Promise<TResponse> {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${userToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    let detail = '';
    try { detail = await res.text(); } catch { /* ignore */ }
    throw new Error(`Request failed: ${res.status} ${res.statusText} ${detail}`);
  }

  // Handle empty responses (e.g., 204 No Content)
  const contentType = res.headers.get('content-type') || '';
  if (!contentType || contentType.includes('text/plain')) {
    // Text or empty
    const text = await res.text();
    return text as unknown as TResponse;
  }
  if (contentType.includes('application/json')) {
    return res.json() as Promise<TResponse>;
  }

  // Fallback: try text
  const fallback = await res.text();
  return fallback as unknown as TResponse;
}
        

        
export function getFileUrl(): Promise<string | null> {
  return new Promise((resolve) => {
    Office.context.document.getFilePropertiesAsync((res) => {
      const url = res?.value?.url ?? "";
      resolve(url || null); // null if not saved
    });
  });
}


export function getFirstWordFromFilename(fileName: string): string {
  // Remove extension
  const base = fileName.replace(/\.[^.]+$/, ""); // drops ".xlsx", ".xlsm", etc.
  // Split on space, hyphen, underscore (one or more)
  const parts = base.split(/[ \-_]+/).filter(Boolean);
  return parts[0] ?? "";
}

export function hasV12InFilename(fileName: string): boolean {
  // Check for 'v12' in filename (case insensitive)
  return /v12/i.test(fileName);
}

export function fileNameFromUrl(urlOrPath: string): string {
  const lastSlash = Math.max(urlOrPath.lastIndexOf("/"), urlOrPath.lastIndexOf("\\"));
  return lastSlash >= 0 ? urlOrPath.slice(lastSlash + 1) : urlOrPath;
}


